<mat-radio-button
    [name]="name"
    [disabled]="disabled"
    (change)="onRadioButtonChanged($event)"
    [value]="value"
    color="primary"
    [checked]="checked">
    <ng-content></ng-content>
</mat-radio-button>
